import { StandardProps } from "../componentMap";
import { StoreStock } from "@/components/__shared__/StoreStock/StoreStock.tsx";
import { isFutureRelease } from "@/utils/variant/isFutureRelease.ts";
import { isAvailableToPreOrder } from "@/utils/variant/isAvailableToPreOrder.ts";
import { HorizontalRule } from "@/components";
import {
  getNotifiableEventType,
  NotAvailable,
} from "@/components/__shared__/NotAvailable/NotAvailable.tsx";
import classNames from "classnames/bind";
import styles from "@/components/OutOfStockActions/OutOfStockActions.module.scss";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { ensureIsActiveVariant } from "@/utils/product/ensureIsActive.ts";
import { isMultiVariants } from "@/utils/product/isMultiVariants.ts";
import { getVariantSkuId } from "@/utils/variant/getVariantSkuId";

export const OutOfStockActions = ({
  product,
  runtimeConfig,
  configProps,
}: Pick<
  StandardProps,
  "product" | "configProps" | "runtimeConfig" | "flags" | "experiencesRawObject"
>) => {
  const cx = classNames.bind(styles);
  const { variant, isSelected } = useVariant(product);
  const activeVariant = ensureIsActiveVariant(variant);
  const notifiableEventType =
    activeVariant !== null
      ? getNotifiableEventType(activeVariant.customerNotifiableEvents)
      : undefined;

  const {
    storeStockScriptUrl,
    stockApiBaseUrl,
    stockApiKey,
    storeStockApiKey,
    storeStockModalApiUrl,
  } = runtimeConfig;
  const hasMultiVariants = isMultiVariants(product);

  if (notifiableEventType === undefined && !hasMultiVariants) return null;

  return (
    <div
      data-component="OutOfStockActions"
      id="OutOfStockTools"
      className={cx("wrapper")}
    >
      <h2>How to get it</h2>
      <StoreStock
        title={variant.title}
        displayCode={variant.displayCode}
        isFutureRelease={isFutureRelease(variant)}
        isPreOrderable={isAvailableToPreOrder(variant)}
        skuId={getVariantSkuId(variant)}
        storeStockApiKey={storeStockApiKey}
        storeStockScriptUrl={storeStockScriptUrl}
        stockApiBaseUrl={stockApiBaseUrl}
        stockApiKey={stockApiKey}
        isVariantSelected={isSelected}
        storeStockModalApiUrl={storeStockModalApiUrl}
        usePrimaryButton={true}
      />

      {notifiableEventType ? (
        <>
          <HorizontalRule />
          <NotAvailable
            configProps={configProps}
            product={product}
            runtimeConfig={runtimeConfig}
          />
        </>
      ) : null}
      <HorizontalRule />
    </div>
  );
};
